import React from 'react';

interface TabTrapperProps {
  children: React.ReactNode;
  isActive?: boolean;
}

interface TabTrapperState {
  shiftKeyIsPressed: boolean;
}

class TabTrapper extends React.Component<TabTrapperProps, TabTrapperState> {
  state: TabTrapperState = {
    shiftKeyIsPressed: false
  };

  previouslyFocusedElement: HTMLElement | null = null;
  beforeWrapper: HTMLDivElement | null = null;
  afterWrapper: HTMLDivElement | null = null;

  componentDidMount() {
    window.addEventListener('keydown', this.onKeyDown);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.onKeyDown);

    if (this.previouslyFocusedElement) {
      this.previouslyFocusedElement.focus();
    }
  }

  componentDidUpdate(prevProps: TabTrapperProps) {
    if (!prevProps.isActive && this.props.isActive) {
      this.previouslyFocusedElement = document.activeElement as HTMLElement;
    }

    if (prevProps.isActive && !this.props.isActive && this.previouslyFocusedElement) {
      this.previouslyFocusedElement.focus();
    }
  }

  onKeyDown = (e: KeyboardEvent) => {
    this.setState({ shiftKeyIsPressed: e.shiftKey });
  };

  trapFirst = () => {
    if (this.afterWrapper) {
      this.afterWrapper.focus();
    }
  };

  trapLast = () => {
    if (this.beforeWrapper) {
      this.beforeWrapper.focus();
    }
  };

  render() {
    const buttonStyle: React.CSSProperties = {
      position: 'absolute',
      width: 0,
      height: 0,
      left: '-999em',
      overflow: 'hidden',
      padding: 0,
      border: 'none'
    };

    return (
      <>
        {this.props.isActive && (
          <button onFocus={this.trapFirst} style={buttonStyle} disabled={!this.state.shiftKeyIsPressed} />
        )}
        <div ref={div => (this.beforeWrapper = div)} tabIndex={-1} />

        {this.props.children}

        <div ref={div => (this.afterWrapper = div)} tabIndex={-1} />
        {this.props.isActive && <button onFocus={this.trapLast} style={buttonStyle} />}
      </>
    );
  }
}

export default TabTrapper;
